import {Stack, Typography} from "@mui/material";

export interface Props {
    header: string;
    value: string | number;
}

export const KeyValueInline: React.FC<Props> = ({header, value}) => {
    const displayValue = typeof value === "number" ? value.toString() : value;
    return (
        <Stack direction="row" gap="1rem" justifyContent="left" alignItems="center">
            <Typography textTransform="uppercase" component="h5" variant="subtitle1">
                {header}:
            </Typography>

            <Typography textTransform="uppercase" sx={{color: "#737990"}} fontSize={14} textOverflow="ellipsis">
                {displayValue}
            </Typography>
        </Stack>
    );
};
